import type { MessageKey } from "./th";

/** English messages. Typed against `th`, so a missing or extra key fails the build. */
export const en: Record<MessageKey, string> = {
  "app.name": "CCA Customer",
  "landing.title": "Shuttle bus times",
  "landing.subtitle": "Scan the QR at the stop or on the bus",
  "landing.scan": "Scan QR",
  "landing.enterCode": "Enter code",

  "scan.title": "Scan QR",
  "scan.aim": "Line the QR up inside the frame",
  "scan.torchOn": "Torch",
  "scan.torchOff": "Torch off",
  "scan.flip": "Flip camera",
  "scan.codePlaceholder": "ABCD-2345",
  "scan.submit": "Continue",
  "scan.hint": "Scan the QR at the stop or on the bus",
  "scan.opening": "Opening the camera...",
  "scan.checking": "Checking...",
  "scan.useCode": "Enter the code instead",
  "scan.codeTitle": "Enter the code from the sticker",
  "scan.codeSub": "The 8 characters printed under the QR",
  "scan.codeEnter": "Continue",
  "scan.retry": "Try again",
  "scan.openSettings": "Open app settings",
  "scan.close": "Close",
  "scan.permissionHelpApp": "Allow camera access in the app's settings, then come back and try again",
  "scan.permissionHelpWeb": "Allow camera access for this site in your browser settings, then try again",
  "err.QR_INVALID": "That QR is not valid — check you scanned the right sticker",
  "err.QR_REVOKED": "This QR has been revoked — ask the operator for a new one",
  "err.QR_EXPIRED": "This QR has expired — ask the operator for a new one",
  "err.QR_NOT_STARTED": "This QR is not valid yet — try again on its start date",
  "err.RATE_LIMITED": "Too many attempts — wait a moment and try again",
  "err.LIST_FULL": "You can hold six at most — remove one you no longer use",
  "err.NETWORK": "Could not reach the server. Try again",
  "err.NO_PERMISSION": "Camera access was not granted",
  "err.NO_CAMERA": "No camera on this device",
  "err.UNKNOWN": "The camera could not be opened. Try again",
  "scan.back": "Back",

  "trips.plate": "Plate",
  "trips.driver": "Driver",
  "trips.none": "No service at this time",
  "trips.offline": "Offline — this may not be the latest",
  "trips.expired": "This QR has expired",
  "trips.notStarted": "This QR has not started yet",

  "nav.addPortal": "Scan another QR",
  "nav.back": "Back",
  "nav.portalList": "List",
  "nav.tabList": "Trips",
  "nav.tabSettings": "Settings",
  "settings.groupGeneral": "General",
  "settings.language": "Language",
  "settings.managePortals": "Manage list",
  "settings.portalActive": "Open now",
  "settings.removeOne": "Remove this one",
  "settings.removeOneBody": "Gone from this phone · the same QR can be scanned again",
  "settings.removeAll": "Remove all",
  "settings.removeAllBody": "Removes every QR from this phone · they can be scanned again",
  "settings.confirmRemove": "Remove",
  "settings.cancel": "Cancel",
  "common.loading": "Loading",
  "nav.language": "Language",
  // ── trip detail ───────────────────────────────────────
  "trip.title": "Trip detail",
  "trip.stops": "stops",
  "trip.km": "km",
  "trip.minutes": "min",
  "trip.depart": "Departs",
  "trip.arriveApprox": "Arrives (approx.)",
  "trip.unscheduled": "Not scheduled",
  "trip.track": "Track the bus on a map",
  "trip.crewLater": "The bus and driver appear 15 minutes before departure",
  "trip.noStops": "No stop information for this trip yet",
  "trip.cancelledNote": "This trip was cancelled — no bus will run",
  "trip.notFound": "Trip not found",
  "trip.backToList": "Back to the list",
  "trip.sessionOver": "The QR has expired — scan it again",
  "trip.point": "stops",

  // ── trip state ────────────────────────────────────────
  "state.running": "On the road",
  "state.upcoming": "Waiting to depart",
  "state.completed": "Arrived",
  "state.cancelled": "Cancelled",

  // ── stop timeline ─────────────────────────────────────
  "stop.planNote": "This trip has no recorded arrival times — the times shown are the plan",
  "stop.origin": "Origin",
  "stop.destination": "Destination",
  "stop.depot": "Depot",
  "stop.next": "Next stop",
  "stop.nearest": "Nearest to you",
  "stop.skipped": "Skipped",
  "stop.passed": "Passed",
  "stop.nth": "Stop",
  "stop.from": "from",
  "stop.dwell": "Dwell",
  "stop.metres": "m",

  // ── map ───────────────────────────────────────────────
  "map.title": "Track the bus",
  "map.vehicle": "Bus",
  "map.plate": "Plate",
  "map.driver": "Driver",
  "map.you": "Your bus",
  "map.goToBus": "Centre on the bus",
  "map.goToMe": "Centre on me",
  "map.loading": "Finding the bus...",
  "map.notYet": "The bus starts sharing its position 15 minutes before departure",
  "map.noSignal": "No GPS signal from this bus yet",
  "map.dead": "The session has expired — scan the QR again",
  "map.justNow": "just now",
  "map.fitAll": "Fit the whole route",
  "map.updated": "Updated",
  "map.onTime": "On time",
  "map.arrived": "Arrived",
  "map.notReached": "Not reached",
  "map.minutesAgo": "min ago",
  "map.hoursAgo": "h ago",
  "map.daysAgo": "d ago",


  "lang.th": "ไทย",
  "lang.en": "English",
};
